import { useState } from 'react';
import ShowInterestFormModal from './ShowInterestFormModal';
import SucessMessageModal from './SucessMessageModal';
const ShowInterestModal = ({
    show,
    onClose,
    dealName,
    slug,
    opportunityId,
    handleIsShowInterestSubmit,
    setShownInterest,
}) => {
    const [showInterestForm, setShowInterestForm] = useState(show);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    return (
        <>
            {showInterestForm && (
                <ShowInterestFormModal
                    show={showInterestForm}
                    onClose={onClose}
                    dealName={dealName}
                    slug={slug}
                    opportunityId={opportunityId}
                    setShowInterestForm={setShowInterestForm}
                    setShowSuccessMessage={setShowSuccessMessage}
                    setShownInterest={setShownInterest}
                    handleIsShowInterestSubmit={handleIsShowInterestSubmit}
                />
            )}
            {showSuccessMessage && (
                <SucessMessageModal
                    show={showSuccessMessage}
                    onClose={onClose}
                />
            )}
        </>
    );
};

export default ShowInterestModal;
